export default __webpack_public_path__ + "media/flags/af-77f5da1e.svg";